const NavLinkBehavior = {
  toNewPage: 'toNewPage',
  scrollTo: 'scrollTo',
  doNothing: 'doNothing'
};

export default NavLinkBehavior;
